import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Navbar = ({ onBook }) => {
  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="fixed top-0 left-0 right-0 z-40 bg-[#003F2E] border-b border-[#D6B15E]/25"
      data-testid="navbar"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-10 h-[68px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
          <img src="/logo-hut.png" alt="Cheshire Holidays" className="h-10 w-auto object-contain" />
          <span className="font-heading text-[#D6B15E] text-xl sm:text-2xl tracking-wide leading-none">
            Cheshire Holidays
          </span>
        </Link>
        {onBook && (
          <button
            onClick={onBook}
            data-testid="navbar-book-btn"
            className="text-xs tracking-widest uppercase border border-[#D6B15E]/50 text-[#D6B15E] px-5 py-2.5 hover:bg-[#D6B15E] hover:text-[#003F2E] transition-colors duration-300"
          >
            Book
          </button>
        )}
      </div>
    </motion.header>
  );
};

export default Navbar;
